<template>
	<div>
		<ul class="toolbar">
			<li>
				<a href="javascript:;" onclick="window.open('http://p.qiao.baidu.com/cps/chat?siteId=14085450&userId=1052055', 'newwindow', 'height=600, width=800,top=50,left=350')">
					<i class="iconfont icon-kefu2"></i>
					售后客服
				</a>
			</li>
			<li>
				<a href="http://wpa.qq.com/msgrd?v=3&uin=951023688&site=qq&menu=yes" target="__blank">
					<i class="iconfont icon-qq"></i>
					备案专员
				</a>
			</li>
			<li>
				<a href="http://help.web724.cn/article/spxxq.html" target="_blank">
					<i class="iconfont icon-shipinjiaoxue"></i>
					教学
				</a>
			</li>
			<li @click="showGuildeline=true">
				<i class="iconfont icon-xinshouzhiyin"></i>
				指引
			</li>
			<li @click="goTop">
				<i class="iconfont icon-huidaodingbu"></i>
				顶部
			</li>
		</ul>
		<Guideline ref="newGuildeline" v-if="showGuildeline" @close="showGuildeline=false" :flag="showGuildeline"></Guideline>
	</div>
</template>

<script>
import Guideline from '../Guideline'

export default {
	data () {
		return {
			showGuildeline: false,
		}
	},
	methods: {
		//返回顶部
		goTop () {
			let scrollToptimer = setInterval(function () {
				let top = document.body.scrollTop || document.documentElement.scrollTop
				let speed = top / 4
				if (document.body.scrollTop != 0) {
					document.body.scrollTop -= speed
				} else {
					document.documentElement.scrollTop -= speed
				}
				if (top == 0) {
					clearInterval(scrollToptimer)
				}
			}, 30)
		},
	},
	created () {

	},
	components: {
		Guideline
	}
}

</script>

<style lang="scss" scoped>
.toolbar {
	position: fixed;
	right: 0;
	top: 50%;
	width: 74px;
	border: 1px solid #efefef;
	margin-top: -200px;
	background: #fff;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	text-align: center;
	z-index: 2006;
	font-size: 14px;
	color: #333;
	line-height: 30px;
	li {
		height: 88px;
		margin: 2px;
		border-bottom: 1px solid #efefef;
		overflow: hidden;
		cursor: pointer;
		transition: 0.3s;
		a {
			display: block;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		i {
			display: block;
			margin-top: 19px;
			font-size: 30px;
			line-height: 30px;
			color: rgba(0, 0, 0, 0.4);
			transition: 0.3s;
		}
		&:hover {
			color: $colorA;
			i,
			a {
				color: $colorA;
			}
		}
		&:last-child {
			margin-bottom: 0;
			border-bottom: 0 none;
		}
	}
	&:after {
		content: '';
		position: absolute;
		top: -3px;
		left: 0;
		width: 100%;
		height: 4px;
		background: $colorA;
	}
}
// 防止屏幕太小
@media (max-width: 1360px) {
	.toolbar {
		background: rgba(255, 255, 255, 0.5);
	}
}
</style>
